import { rankingData } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500/10 border border-accent-500/20 text-xs font-medium text-accent-400 mb-3">
            <i className="ri-fire-line"></i>
            热门排行
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热播榜单</h2>
          <p className="mt-2 text-sm text-foreground-500">全网热门影视实时热度排名</p>
        </div>

        <div className="rounded-2xl bg-background-100 border border-background-200/60 overflow-hidden">
          <div className="hidden md:grid grid-cols-12 gap-4 px-6 py-3 bg-background-200/50 text-xs font-medium text-foreground-400 border-b border-background-200/60">
            <div className="col-span-1">排名</div>
            <div className="col-span-4">影片名称</div>
            <div className="col-span-2">类型</div>
            <div className="col-span-2">热度值</div>
            <div className="col-span-2">趋势</div>
            <div className="col-span-1"></div>
          </div>

          {rankingData.map((item, idx) => (
            <div
              key={item.rank}
              className={`grid grid-cols-1 md:grid-cols-12 gap-3 md:gap-4 px-4 md:px-6 py-4 items-center border-b border-background-200/40 last:border-b-0 hover:bg-background-200/30 transition-colors ${
                idx < 3 ? 'bg-primary-500/[0.03]' : ''
              }`}
            >
              <div className="md:col-span-1 flex items-center gap-3 md:gap-0">
                <span
                  className={`w-7 h-7 flex items-center justify-center rounded-lg text-xs font-bold ${
                    item.rank === 1
                      ? 'bg-accent-500 text-background-50'
                      : item.rank === 2
                        ? 'bg-primary-500 text-background-50'
                        : item.rank === 3
                          ? 'bg-secondary-500 text-background-50'
                          : 'bg-background-200 text-foreground-500'
                  }`}
                >
                  {item.rank}
                </span>
                {item.isNew && (
                  <span className="md:hidden px-1.5 py-0.5 rounded text-[10px] font-semibold bg-accent-500/15 text-accent-400">新</span>
                )}
              </div>

              <div className="md:col-span-4">
                <span className="text-sm font-semibold text-foreground-800">{item.title}</span>
              </div>

              <div className="md:col-span-2">
                <span className="inline-block px-2.5 py-0.5 rounded-full text-xs bg-secondary-100 text-secondary-600">{item.category}</span>
              </div>

              <div className="md:col-span-2">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-bold text-foreground-700 font-heading">{item.hot}</span>
                  <span className="text-xs text-foreground-500">热度</span>
                </div>
              </div>

              <div className="md:col-span-2">
                <span className={`inline-flex items-center gap-1 text-xs font-medium ${
                  item.trend === 'up' ? 'text-green-400' :
                  item.trend === 'hot' ? 'text-accent-400' :
                  'text-foreground-500'
                }`}>
                  <i className={`text-xs ${
                    item.trend === 'up' ? 'ri-arrow-up-line' :
                    item.trend === 'hot' ? 'ri-fire-line' :
                    'ri-subtract-line'
                  }`}></i>
                  {item.trend === 'up' ? '上升' : item.trend === 'hot' ? '热门' : '稳定'}
                </span>
              </div>

              <div className="md:col-span-1">
                {item.isNew && (
                  <span className="hidden md:inline-block px-1.5 py-0.5 rounded text-[10px] font-semibold bg-accent-500/15 text-accent-400">NEW</span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}